import { IApplicationState } from '../../types/redux';
import { IResidentialComplex } from '../../types/residentials';
import { mapOrder } from '../../utils';

export function getFilteredResidentialComplexes(state: IApplicationState): IResidentialComplex[] {
  const {
    residentialComplexesIds,
    residentialComplexes: { hash, list },
  } = state;

  const order = list.map(complex => Number(complex.id));
  const filteredComplexesIdsByOrder = mapOrder(residentialComplexesIds, order);

  return filteredComplexesIdsByOrder.map(id => hash[id]).filter(Boolean);
}
